import * as caseTypes from './casesTypes';
import {
  getCaseFiltersAPI,
  getImmigrationPathway,
  saveCasePathway,
  fetchCases,
  fetchCaseDetail,
  fetchDetailsHeader,
  updateCasePhaseService,
  fetchCasePhasesService,
  getLineManagersAPI,
  getClientLineManagersAPI,
  saveAddNewLineManagersAPI,
  fetchMessagesCount,
} from 'src/services/cases.service';
//import { getCaseManagerId } from './casesReselect';
/** work converted from sagas **/

export const getCaseDetails = caseManagerId => {
  return async (dispatch, getState) => {
    /* two pieces to the details page: Details information + Details Header */
    const [detailsResult, detailsHeaderResult] = await Promise.all([fetchCaseDetail(caseManagerId), fetchDetailsHeader(caseManagerId)]);

    if (detailsResult && detailsHeaderResult) {
      dispatch(getCaseDetailsSuccess(detailsResult, detailsHeaderResult));
    }
  };
};

export const getCaseDetailsSuccess = (caseDetails, caseDetailsHeader) => ({
  type: caseTypes.GET_CASE_DETAILS_SUCCESS,
  caseDetails,
  caseDetailsHeader,
});

/** work converted from sagas **/

export const getCaseIdsPending = statusType => ({
  type: caseTypes.GET_CASE_IDS_PENDING,
  statusType,
});

export const getCaseIdsSuccess = payload => ({
  type: caseTypes.GET_CASE_IDS_SUCCESS,
  payload,
});

export const getCaseIdsFailure = error => ({
  type: caseTypes.GET_CASE_IDS_FAILURE,
  error,
});

export const getCaseDetailPending = caseId => ({
  type: caseTypes.GET_CASE_DETAIL_PENDING,
  caseId,
});

export const getCaseDetailSuccess = data => ({
  type: caseTypes.GET_CASE_DETAIL_SUCCESS,
  data,
});

export const getCaseDetailFailure = error => ({
  type: caseTypes.GET_CASE_DETAIL_FAILURE,
  error,
});

export const getCasesSuccess = payload => {
  return dispatch => {
    dispatch({
      type: caseTypes.GET_CASES_SUCCESS,
      payload,
    });
  };
};

export const getCasesPending = (params, config) => {
  return async dispatch => {
    dispatch(isLoading(caseTypes.LOADING_CASES, true));
    await fetchCases(params, config)
      .then(res => {
        if (res && !res.error) {
          dispatch(getCasesSuccess(res));
        }
        dispatch(isLoading(caseTypes.LOADING_CASES, false));
      })
      .catch(err => {
        console.error(err);
        dispatch(isLoading(caseTypes.LOADING_CASES, false));
        throw new Error(err);
      });
  };
};

export const getCasesFailure = error => ({
  type: caseTypes.GET_CASE_DETAIL_FAILURE,
  error,
});

// toggle modal shut, getCases with caseFilters payload
export const applyCasesFilters = caseFilters => {
  return async dispatch => {
    await fetchCases(caseFilters)
      .then(res => {
        if (res && !res.error) {
          dispatch(getCasesSuccess(res));
        } else {
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const applyFiltersSuccess = () => ({
  type: caseTypes.APPLY_CASES_FILTERS_SUCCESS,
});

export const applyFiltersFailure = () => ({
  type: caseTypes.APPLY_CASES_FILTERS_SUCCESS,
});

//showModal
export const toggleModal = (status, anchorEl) => ({
  type: caseTypes.SHOW_FILTER_MODAL,
  status,
  anchorEl,
});

export const goToDetails = rowData => ({
  type: caseTypes.GO_TO_DETAILS,
  rowData,
});

// filters
export const getCaseFilters = () => {
  return async dispatch => {
    await getCaseFiltersAPI()
      .then(res => {
        dispatch(getCaseFiltersSuccess(res));
      })
      .catch(err => {
        console.error(err);
        throw new Error(err);
      });
  };
};

export const getCaseFiltersSuccess = payload => ({
  type: caseTypes.GET_FILTERS_SUCCESS,
  payload,
});

export const getImmigrationPathwayList = () => {
  return async dispatch => {
    const res = await getImmigrationPathway();
    if (res.success) dispatch(getImmigrationPathwayListSuccess(res.pathways));
  };
};

export const savePathway = (payload, cb = res => {}) => {
  return async (dispatch, getState) => {
    const response = await saveCasePathway(payload);
    if (response && response.success) {
      cb(true);
    } else cb(false);
  };
};

export const getImmigrationPathwayListSuccess = payload => ({
  type: caseTypes.GET_IMMIGRATION_PATHWAY_SUCCESS,
  payload,
});

export const getCaseMessagesCountsSuccess = data => ({
  type: caseTypes.GET_CASES_MESSAGES_COUNTS_SUCCESS,
  data,
});

export const getCaseMessagesCountsFailure = err => ({
  type: caseTypes.GET_CASES_MESSAGES_COUNTS_FAILURE,
  err,
});

export const resetCaseManagerId = () => ({
  type: caseTypes.RESET_CASE_MANAGER_ID,
});

export const storeCaseDetails = caseDetails => ({
  type: caseTypes.STORE_CASE_DETAILS,
  caseDetails,
});

export const storeCaseManagerId = caseManagerId => ({
  type: caseTypes.STORE_CASE_MANAGER_ID,
  caseManagerId,
});

export const getCaseMessagesCountsPending = () => ({
  type: caseTypes.GET_CASES_MESSAGES_COUNTS_PENDING,
});

export const getCasePhasesSuccess = data => ({
  type: caseTypes.GET_CASE_PHASES_SUCCESS,
  data,
});

export const resetCasesCounts = () => ({
  type: caseTypes.RESET_CASES_MESSAGES_COUNTS,
});

export const getCasePhases = caseManagerId => {
  return async dispatch => {
    const response = await fetchCasePhasesService({ caseManagerId });
    if (response && response.success) {
      dispatch(getCasePhasesSuccess(response));
    }
  };
};

export const updateCasePhase = data => {
  return async dispatch => {
    const response = await updateCasePhaseService(data);
    if (response && response.success) {
      dispatch(getCasePhases(data.caseManagerId));
    }
  };
};

/* line managers api */

export const getLineManagersFilterSuccess = payload => ({
  type: caseTypes.GET_CASE_LM_FILTER_SUCCESS,
  payload,
});

export const getLineManagersSuccess = payload => ({
  type: caseTypes.GET_CASE_LM_SUCCESS,
  payload,
});

export const getLineManagersError = payload => ({
  type: caseTypes.GET_CASE_LM_ERROR,
  payload,
});

export const getClientLineManagersSuccess = payload => ({
  type: caseTypes.GET_CASE_CLIENT_LM_SUCCESS,
  payload,
});

export const getClientLineManagersError = payload => ({
  type: caseTypes.GET_CASE_CLIENT_LM_ERROR,
  payload,
});

export const setClientLineManagersCount = payload => ({
  type: caseTypes.SET_CASE_LM_COUNT,
  payload,
});

export const saveAddNewLineManagersSuccess = data => ({
  type: caseTypes.SAVE_CASE_CLIENT_NEW_LM_SUCCESS,
  data,
});

export const getClientLineManagers = params => {
  return async dispatch => {
    const response = await getClientLineManagersAPI(params);
    if (response && response.success) {
      dispatch(getClientLineManagersSuccess(response.corporateClientLineManagers));
    } else if (response && !response.success) {
      dispatch(getClientLineManagersError(response.error));
    }
  };
};

export const getLineManagers = id => {
  return async dispatch => {
    const response = await getLineManagersAPI({ caseManagerId: id });
    if (response && response.success) {
      dispatch(getLineManagersSuccess(response.caseLineManagers));
      dispatch(setClientLineManagersCount(response.caseLineManagers.length));
    } else if (response && !response.success) {
      dispatch(getLineManagersError(response.error));
    }
  };
};

export const getLineManagersCount = id => {
  return async dispatch => {
    const response = await getLineManagersAPI({ caseManagerId: id });
    if (response && response.success) {
      dispatch(setClientLineManagersCount(response.caseLineManagers.length));
    }
  };
};
export const getCaseLineFilters = id => {
  return async dispatch => {
    const response = await getLineManagersAPI({ caseManagerId: id });
    if (response && response.success) {
      dispatch(getLineManagersFilterSuccess(response.caseLineManagers));
    }
  };
};

export const saveAddNewLineManagersData = params => {
  return async dispatch => {
    const response = await saveAddNewLineManagersAPI(params);
    if (response) {
      return response;
    }
  };
};

export const storeCasesFilters = data => ({
  type: caseTypes.STORE_CASES_FILTERS,
  data,
});

export const setCaseLoading = payload => ({
  type: caseTypes.LOADING_CASES,
  payload,
});

export const getMessagesCount = caseId => {
  return async dispatch => {
    dispatch(isLoading(caseTypes.LOADING_MESSAGES_COUNT, true));
    await fetchMessagesCount(caseId)
      .then(res => {
        if (res != null && !res.error) {
          dispatch(getMessagesCountSuccessful(res));
          dispatch(isLoading(caseTypes.LOADING_MESSAGES_COUNT, false));
        } else throw new Error(res.error.message);
      })
      .catch(err => {
        console.log(err);
      });
  };
};
export const getMessagesCountSuccessful = payload => {
  return {
    type: caseTypes.FETCH_MESSAGES_COUNT_SUCCESS,
    payload,
  };
};

export const resetCaseDetails = () => ({
  type: caseTypes.RESET_CASE_DETAILS,
});

export const isLoading = (type, isLoading) => {
  return {
    type,
    isLoading,
  };
};

export const updateAdditionalInfoFound = value => {
  return async dispatch => {
    const { isAdditionalInfoSecExist, hasAdditionalInfo } = value;
    let action = {
      type: caseTypes.UPDATE_ADDITIONAL_INFO_STATUS,
      isAdditionalInfoSecExist,
      hasAdditionalInfo,
    };
    dispatch(action);
  };
};

export const updateAdditionalInfoData = value => {
  return async dispatch => {
    const { isAdditionalInfoSecExist, hasAdditionalInfo, additionalInfoData } = value;
    let action = {
      type: caseTypes.UPDATE_ADDITIONAL_INFO_DATA,
      isAdditionalInfoSecExist,
      hasAdditionalInfo,
      additionalInfoData,
    };
    dispatch(action);
  };
};

export const updateMainCaseInfoData = value => {
  return async dispatch => {
    let action = {
      type: caseTypes.UPDATE_MAIN_CASE_INFO_DATA,
      caseInfoData: value,
    };
    dispatch(action);
  };
};

export const setNewAdditionalInfoRecord = value => {
  return async dispatch => {
    let action = {
      type: caseTypes.SET_NEW_ADDITIONAL_INFO_RECORD_ID,
      newAdditionalInfoRecordId: value,
    };
    dispatch(action);
  };
};

export const setBpfStatusInfo = value => {
  return async dispatch => {
    let action = {
      type: caseTypes.SET_BPF_STATUS_INFO,
      bpfStatusInfo: value,
    };
    dispatch(action);
  };
};

export default {
  getLineManagersCount,
  saveAddNewLineManagersData,
  getCaseLineFilters,
  getLineManagers,
  getCaseMessagesCountsPending,
  getCaseIdsPending,
  getCaseIdsSuccess,
  getCaseIdsFailure,
  getCaseDetailPending,
  getCaseDetailSuccess,
  getCaseDetailFailure,
  getCasesPending,
  getCasesSuccess,
  getCasesFailure,
  getCaseFilters,
  storeCaseManagerId,
  toggleModal,
  getImmigrationPathwayList,
  savePathway,
  getMessagesCount,
  resetCaseDetails,
  updateAdditionalInfoFound,
  updateAdditionalInfoData,
  updateMainCaseInfoData,
  setNewAdditionalInfoRecord,
  setBpfStatusInfo,
  setCaseLoading,
};
